import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToString',
  standalone: false,
})
export class EnumToStringPipe implements PipeTransform {
  transform(value: string | number, enumType: any, kebab?: boolean): string {
    if (value == null) {
      return null;
    }
    const enumValue = typeof value !== 'string' || !isNaN(parseInt(value)) ? enumType[value] : value;
    if (!enumValue || enumValue.toString() === enumValue.toString().toUpperCase()) {
      return enumValue;
    }
    if (kebab) {
      return enumValue
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
    }
    return enumValue.replace(/([A-Z])/g, ' $1').trim();
  }
}
